// extracted by mini-css-extract-plugin
export default {"logo":"errorMessage_styles_logo__Mwai5","messageWrapper":"errorMessage_styles_messageWrapper__e3oMe"};